<template>
  <div id="app">
    <router-view />

    <dg-form-dialog :close-on-click-modal="false" :close="false" :visible.sync="agreementsVisible" width="800px">
      <div class="mt-[-20]" id="protocoHtml">
        <el-tabs v-model="agreementIndex">
          <el-tab-pane :label="v.title" :name="`${index}`" v-for="(v, index) in confirmAgreements" :key="index">
            <div v-html="v.content" class="h-[500] overflow-y-auto"></div>
          </el-tab-pane>
        </el-tabs>
        <div class="text-center">
          <el-button class="" size="small" @click="logout">不同意并退出登录 </el-button>
          <!-- :disabled="!countDownStatus" -->

          <el-button class="" v-if="agreementsVisible" size="small" :disabled="countDownStatus[Number(agreementIndex)] == 0 || countDownStatus[Number(agreementIndex)] == 1 || countDownStatus[Number(agreementIndex)] == 3" type="primary" @click="handleAgreement"> {{ countDownStatus[Number(agreementIndex)] == 1 ? `请阅读本协议/政策后再同意（${countDownNumber}S）` : "请阅读本协议/政策后再同意" }} </el-button>
        </div>
      </div>
    </dg-form-dialog>
  </div>
</template>

<script>
import { isIE, countDown } from "@/assets/js/utils";
import mixin from "@/assets/js/mixin";
export default {
  mixins: [mixin],
  name: "App",
  data() {
    return {
      msg: 10,
      vwPath: false,
      agreementsVisible: false,
      countDownNumber: 5,
      confirmAgreements: [], // 禁用0  倒计时 1 倒计时完成 2 已同意 3
      countDownStatus: [], // 禁用0  倒计时 1 倒计时完成 2 已同意 3
      agreementIndex: "0", // 禁用0  倒计时 1 倒计时完成 2
    };
  },
  watch: {
    $route: {
      handler(val) {
        let vwPath = ["externalSignSignature"];
        if (vwPath.indexOf(val.name) == -1) {
          console.log("pppp");
          this.vwPath = false;
        } else {
          this.vwPath = true;
        }
        this.ca_back();
        let NoAgreement = ["login", "register", "protocolRegister", "modifyPasw", "forgetPasw"];

        if (NoAgreement.indexOf(this.$route.name) == -1) {
          this.getCurrent((res) => {
            localStorage.setItem("current", JSON.stringify(res));

            if (res.enterprise.needReadAgreement == true) {
              this.getProtocolList(() => {
                this.startCountDown();
              });
            }
          });
        } else {
          this.agreementsVisible = false;
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
  methods: {
    /**
     * @author 伟健 / 张
     * @name 关闭页面
     */
    handlerCloseWindow() {
      location.href = "about:blank";
    },
    /**
     * @author 伟健 / 张
     * @name 同意协议
     */
    handleAgreement() {
      ajax.post({
        url: "/supplyChain/user/agreeProtocolDetail",
        data:
          // http://api.jfyancheng.com:8080/doc.html#/default/%E4%BE%9B%E5%BA%94%E9%93%BE-%E8%AE%A4%E8%AF%81%E6%A8%A1%E5%9D%97/agreeProtocolDetailUsingPOST
          {
            agree: 1, // 是否同意,0为不同意，1为同意
            id: this.confirmAgreements[Number(this.agreementIndex)].id, // 协议id
          },
        self: this,
        success: () => {
          this.countDownStatus[Number(this.agreementIndex)] = 3;
          if (Number(this.agreementIndex) == this.confirmAgreements.length - 1) {
            this.agreementsVisible = false;
            return;
          }
          this.agreementIndex = `${Number(this.agreementIndex) + 1}`;
          this.startCountDown();
        },
        fail: () => {},
      });
    },
    /**
     * @author 伟健 / 张
     * @name 用户协议
     */
    getProtocolList(fn) {
      ajax.post({
        url: "/supplyChain/auth/getUserProtocol",
        data: {
          code: 3,
        },
        self: this,
        success: (res) => {
          this.confirmAgreements = res;
          this.countDownStatus = new Array(res.length).fill(0);
          this.agreementsVisible = true;
          fn && fn();
        },
        fail: () => {},
      });
    },
    /**
     * @author 伟健 / 张
     * @name 开始倒计时
     */
    startCountDown() {
      this.countDownStatus[Number(this.agreementIndex)] = 1;
      countDown.apply(this, [
        "countDownNumber",
        () => {
          this.countDownStatus[Number(this.agreementIndex)] = 2;
        },
      ]);
    },
    /* 
    http://uservue2.jinfu.baohan.com/supplyChain/seal/jiangXiSealCommit?taction=GongcTenderbidInsure&token=f47fef44401eeaf23f75302169ef6caa7b7547c45fe3f3efc71148270bac79ef&tradeNo=20220922145533bbVwLsRhAJKGPV&tv=v1
    */
    bodyScale() {
      var devicewidth = document.documentElement.clientWidth; //获取当前分辨率下的可是区域宽度

      var scale = devicewidth / 1920; // 分母——设计稿的尺寸
      // @ts-ignore
      document.body.style.zoom = scale; //放大缩小相应倍数
    },

    ca_back() {
      if (isIE()) {
        // 判断是否为同意驱动跳转的
        // console.log(window.location.pathname.indexOf("ca"));
        // console.log(!this.$route.query.token);
        if (window.location.pathname.indexOf("ca") > -1 && !this.$route.query.token) {
          window.history.back(-1);
        }
      }
    },
    /**
     * @author 伟健 / 张
     * @name 用户信息
     */
    getCurrent(fn) {
      ajax.post({
        url: "/supplyChain/user/current?type=check",
        data: {},
        self: this,
        success: (res) => {
          fn && fn(res);
        },
        fail: () => {},
      });
    },
    /**
     * @author 伟健 / 张
     * @name 退出登陆
     */
    logout() {
      ajax.post({
        url: "/supplyChain/auth/logout",
        data: {},
        success: (res) => {
          if (res) {
            localStorage.clear();
            sessionStorage.clear();
            this.back({ path: "/login" });
          }
        },
        fail: () => {},
      });
    },
  },
  mounted() {
    if (isIE()) {
      window.addEventListener(
        "hashchange",
        () => {
          const currentPath = window.location.hash.slice(1);

          if (this.$route.path !== currentPath && this.$route.path.indexOf("/external") > -1) {
            window.location.reload();
          }
        },
        false
      );
      this.ca_back();
    }
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/css/var.less";
#app-wrap,
#app {
  height: 100vh;
  background: #f7f7f9;
  min-width: 1400px;
  /* width: 100vw; */
}
.el-form-item__label {
  padding-right: 4px;
}

/* 修改个别 el-input 高度 */
.large_input input {
  height: 48px;
  box-shadow: inset 0 2px 1px 0 hsla(0, 0%, 93.3%, 0.9333333333333333) !important;
}

.el-breadcrumb__inner.is-link {
  color: #606266;
  font-weight: 400;
}

.el-breadcrumb__separator {
  margin-left: 5px;
  margin-right: 5px;
}

.el-breadcrumb__item:last-child .el-breadcrumb__inner {
  color: #000;

  &:hover {
    color: #000;
  }
}

img {
  image-rendering: -moz-crisp-edges;
  image-rendering: -o-crisp-edges;
  image-rendering: -webkit-optimize-contrast;
  image-rendering: crisp-edges;
  -ms-interpolation-mode: nearest-neighbor;
}
</style>
 <style>.mt-\[-20\] {
    margin-top: -20px
}
.h-\[500\] {
    height: 500px
}
.overflow-y-auto {
    overflow-y: auto
}
.text-center {
    text-align: center
}</style>